export const ErrorPage = () => {
  return <>ErrorPage</>;
};
